import makeStyles from "@mui/styles/makeStyles";
import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import { HiOutlineChartSquareBar } from "react-icons/hi";
import { TbClipboardList } from "react-icons/tb";

export const BoxContainerInfoCard = styled(Box)(() => ({
  backgroundColor: "#EDF5FB",
}));

export const TextLink = styled("a")(() => ({
  color: "#308CDB !important",
}));

export const BoxIconInfoCard = styled(Box)(() => ({
  backgroundColor: "#3F6280",
}));

export const MainStack = styled(Stack)(({ theme }) => ({
  height: "100%",
  width: "100%",
  display: "flex",
  backgroundColor: "#F3F4F7",
  padding: "100px 120px",
  [theme.breakpoints.down("lg")]: {
    padding: "60px 40px",
  },
}));

export const GridItemInfo = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FAFCFE",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const GridItemForm = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  padding: "47px 24px 0 24px",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 40px 0 40px",
    width: "100%",
  },
}));

export const Logo = styled("img")(() => ({
  width: "180px",
}));

export const HiOutlineChartSquareBarIcon = styled(HiOutlineChartSquareBar)(() => ({
  fontSize: "20px",
}));

export const StackFooter = styled(Stack)(({ theme }) => ({
  marginBottom: "60px !important",
  [theme.breakpoints.down("lg")]: {
    marginBottom: "20px !important",
  },
}));

export const TbClipboardListIcon = styled(TbClipboardList)(() => ({
  fontSize: "20px",
}));

export const TypographyButton = styled(Typography)(() => ({
  cursor: "pointer",
}));

export const InactiveStep = styled(Box)(() => ({
  backgroundColor: "#EDF5FB",
  borderRadius: "4px",
  width: "48px",
  height: "4px",
}));

export const ActiveStep = styled(Box)(() => ({
  backgroundColor: "#308CDB",
  borderRadius: "4px",
  width: "48px",
  height: "4px",
}));

export const useStyles = makeStyles(() => ({
  modal: {
    width: "auto",
  },
}));
